import { getTutorialsLink } from "@/api/instance";

/** Repli si l'API ne répond pas : le visiteur tombe sur le formulaire WordPress. */
const TUTORIALS_FALLBACK_URL = "https://inventozen.com/index.php/tutos/";

/**
 * Ouvre la page « Tutoriels » du site vitrine dans un nouvel onglet.
 *
 * L'URL est fabriquée par l'API et porte le mot de passe de la page WordPress
 * dans `?iz_access=…` : un script du site vitrine le recopie dans le formulaire
 * de mot de passe et le soumet. Le mot de passe n'est donc pas dans le bundle.
 *
 * L'onglet est ouvert de façon synchrone (avant l'await) pour éviter le
 * bloqueur de pop-up, comme pour `openPublicSiteWithBypass`.
 */
export async function openTutorials(): Promise<void> {
  const tab = window.open("", "_blank");
  try {
    const { url } = await getTutorialsLink();
    const target = url || TUTORIALS_FALLBACK_URL;
    if (tab) tab.location.href = target;
    else window.open(target, "_blank");
  } catch {
    if (tab) tab.location.href = TUTORIALS_FALLBACK_URL;
    else window.open(TUTORIALS_FALLBACK_URL, "_blank");
  }
}
